<template>
  <div
    class="d-flex flex-row"
    style="border: 1px solid; position: relative"
    :style="{
    'border-color': modeAdd?'blue':'black'
    }"
  >
    <div
      v-if="isSaveRequest"
      class="eclipse"
      style="
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 100;
      background-color: rgba(0,0,0,0.5);
      display: flex;
      justify-content: center;
      align-items: start;
    "
    >
      <v-progress-linear
        indeterminate
        color="white"
        class="mb-0"
      ></v-progress-linear>
    </div>
    <v-row class="ma-0 px-1">
      <v-col
        class="pa-0 d-flex flex-row"
        cols="12"
        md="5">
        <date-picker
          v-model="item.datetime"
          prepend-icon="mdi-calendar-clock"
          :label="lang($store, 'sap/listings.global.filter.hints.datetime')"
          :rules="[rules.required]"
          :locale="getCurrentLocale()"
          @change="updateRequest('datetime', $event), removeError('phone')"
          :loading="isRequestingNow.includes('datetime')"
        />
        <v-select
          v-model="item.region"
          :items="regionsItems"
          prepend-icon="mdi-home-city-outline"
          single-line
          :hint="lang($store, 'sap/listings.global.filter.hints.region')"
          persistent-hint
          :error-messages="(errors && errors.region)?errors.region:null"
          @change="updateRequest('region', $event); removeError('region')"
          :loading="isRequestingNow.includes('region')"
        ></v-select>
      </v-col>
      <v-col
        class="pa-0 d-flex flex-row"
        cols="12"
        md="7">
        <field-phone
          v-model="item.phone"
          :rules="[rules.required, rules[initPhoneRule]]"
          :error-messages="(errors && errors.phone)?errors.phone:null"
          @input="removeError('phone')"
          @change="updateRequest('phone', $event)"
          :loading="isRequestingNow.includes('phone')"
        />
        <v-text-field
          v-model="item.name"
          :counter="200"
          :rules="[rules.max(200), rules.required]"
          prepend-icon="mdi-account-badge-outline"
          :label="lang($store, 'sap/listings.global.filter.hints.name')"
          autocomplete="off"
          :error-messages="(errors && errors.name)?errors.name:null"
          @input="removeError('name')"
          @change="updateRequest('name', $event)"
          :loading="isRequestingNow.includes('name')"
        ></v-text-field>
      </v-col>
      <v-col
        class="pa-0 d-flex flex-row"
        cols="12"
        md="6">
        <v-select
          v-model="item.type"
          :items="phonesOrderTypeItems"
          single-line
          :hint="lang($store, 'sap/listings.global.filter.hints.type')"
          persistent-hint
          :error-messages="(errors && errors.type)?errors.type:null"
          @change="updateRequest('type', $event); removeError('type')"
          :loading="isRequestingNow.includes('type')"
        ></v-select>
        <v-select
          v-model="item.status"
          :items="phonesOrderStatusItems"
          single-line
          :hint="lang($store, 'sap/listings.global.filter.hints.now_status')"
          persistent-hint
          :error-messages="(errors && errors.region)?errors.region:null"
          @change="updateRequest('status', $event); removeError('status')"
          :loading="isRequestingNow.includes('status')"
        ></v-select>
      </v-col>
      <v-col
        class="pa-0 d-flex flex-row"
        cols="12"
        md="6">
        <v-select
          v-model="item.general_status"
          :items="phonesOrderGeneralStatusItems"
          single-line
          :hint="lang($store, 'sap/listings.global.filter.hints.status')"
          persistent-hint
          :error-messages="(errors && errors.region)?errors.region:null"
          @change="updateRequest('general_status', $event); removeError('general_status')"
          :loading="isRequestingNow.includes('general_status')"
        ></v-select>
        <v-text-field
          v-model="item.area_meters"
          :rules="[rules.int]"
          :label="lang($store, 'sap/listings.global.filter.hints.area_meters')"
          prepend-icon="mdi-counter"
          required
          autocomplete="off"
          :error-messages="(errors && errors.area_meters)?errors.area_meters:null"
          @input="removeError('area_meters')"
          @change="updateRequest('area_meters', $event);"
          :loading="isRequestingNow.includes('area_meters')"
        ></v-text-field>
      </v-col>
      <v-col
        class="pa-0"
        cols="12"
        md="12">
        <v-text-field
          v-model="item.note"
          :counter="200"
          :rules="[rules.max(200)]"
          prepend-icon="mdi-tooltip-text-outline"
          :label="lang($store, 'sap/listings.global.filter.hints.note')"
          autocomplete="off"
          :error-messages="(errors && errors.note)?errors.note:null"
          @input="removeError('note')"
          @change="updateRequest('note', $event)"
          :loading="isRequestingNow.includes('note')"
        ></v-text-field>
      </v-col>
      <v-col cols="12" v-if="modeAdd || showComment">
        <v-textarea
          v-model="item.comment"
          :counter="3000"
          :rules="[rules.max(3000)]"
          prepend-icon="mdi-comment"
          :label="lang($store, 'sap/listings.global.filter.hints.minicomment')"
          autocomplete="off"
          :error-messages="(errors && errors.comment)?errors.comment:null"
          @input="removeError('comment')"
        ></v-textarea>
      </v-col>
    </v-row>
    <div class="d-flex flex-column justify-center align-center pl-1"
         style="border-left: 1px solid"
    >
      <v-btn text icon
             @click="clickDelete"
             v-if="!modeAdd"
      >
        <v-icon>mdi-trash-can-outline</v-icon>
      </v-btn>
      <v-tooltip bottom v-if="!modeAdd"
                 :disabled="!item.comment || ['xs', 'sm'].includes(this.$vuetify.breakpoint.name)"
                 max-width="400px"
      >
        <template v-slot:activator="{ on }">
          <v-btn text icon
                 v-on="on"
                 @click="showComment = !showComment"
          >
            <v-icon>mdi-comment</v-icon>
          </v-btn>
        </template>
        <span>{{ item.comment }}</span>
      </v-tooltip>
      <v-btn text icon
             color="red"
             @click="clickSave"
             v-if="modeAdd"
      >
        <v-icon>mdi-content-save</v-icon>
      </v-btn>
      <v-btn text icon
             color="black"
             @click="clickCancel"
             v-if="modeAdd"
      >
        <v-icon>mdi-cancel</v-icon>
      </v-btn>
    </div>
  </div>

</template>

<script>
import moment from 'moment';
import validationMixin from '@/mixins/validationMixin';
import regionsFilter from '@/mixins/filters/regionsFilter';
import DatePicker from '@/components/DatePicker.vue';
import FieldPhone from '@/components/text-fields/FieldPhone.vue';
import phonesOrderTypeFilter from '@/mixins/filters/phonesOrderTypeFilter';
import phonesOrderStatusFilter from '@/mixins/filters/phonesOrderStatusFilter';
import * as phonesConst from '@/constants/phones_constants';
import { DATE_ISO } from '@/constants/dates';
import FormPhoneProxy from '@/proxies/FormPhones/FormPhoneProxy';
import { prepareValidationMessages } from '@/utils';
import phonesOrderGeneralStatusFilter from '@/mixins/filters/phonesOrderGeneralStatusFilter';
import phoneMixin from '@/mixins/phoneMixin';
import i18n from '@/i18n';

export default {
  name: 'PhoneRow',
  mixins: [
    validationMixin,
    regionsFilter,
    phonesOrderTypeFilter,
    phonesOrderStatusFilter,
    phonesOrderGeneralStatusFilter,
    phoneMixin,
  ],
  components: {
    FieldPhone,
    DatePicker,
  },
  props: {
    default: {
      type: Object,
      default: () => ({}),
    },
    modeAdd: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      useNullableRegion: false,
      useNullablePhonesOrderStatus: false,
      useNullablePhonesOrderGeneralStatus: false,
      useNullablePhonesOrderType: false,
      item: {},
      defaultItem: {
        uuid: '',
        datetime: moment()
          .format(DATE_ISO),
        region: 'kyiv',
        phone: '',
        name: '',
        area_meters: '0',
        type: phonesConst.types.PER_HOUR,
        status: phonesConst.statuses.SELECTS,
        general_status: phonesConst.generalStatuses.OPEN,
        note: '',
      },
      errors: {},
      isRequestingNow: [],
      isSaveRequest: false,
      showComment: false,
    };
  },
  created() {
    this.item = Object.assign(this.defaultItem, this.item, this.default);
  },
  methods: {
    getCurrentLocale() {
      return window.localStorage.language;
    },
    getUpdateSimpleRequestClient() {
      return new FormPhoneProxy();
    },
    updateSimpleRequest(item, property) {
      return (value) => {
        const data = {};
        switch (property) {
          case 'datetime':
            data[property] = value.format('YYYY-MM-DD');
            break;
          default:
            data[property] = value;
            break;
        }
        return this.getUpdateSimpleRequestClient()
          .update(item.uuid, data);
      };
    },
    updateRequest(property, val) {
      if (!this.modeAdd && !this.pageLoading) {
        this.isRequestingNow.push(property);
        (this.updateSimpleRequest(this.item, property))(val)
          .catch((response) => {
            this.errors = prepareValidationMessages(response.data.data);
          })
          .finally(() => {
            const index = this.isRequestingNow.indexOf(property);
            if (index !== -1) this.isRequestingNow.splice(index, 1);
          });
      }
    },
    clickCancel() {
      this.item = Object.assign({}, this.defaultItem);
      this.$emit('cancel');
    },
    clickDelete() {
      const isDelete = confirm( `${i18n.t('actions.delete')} ????`);
      if (isDelete) {
        this.isSaveRequest = true;
        new FormPhoneProxy().destroy(this.item.uuid)
          .then(() => {
            this.$emit('deleted');
          });
      }
    },
    clickSave() {
      this.isSaveRequest = true;
      new FormPhoneProxy()
        .create({
          datetime: this.item.datetime.format('YYYY-MM-DD'),
          type: this.item.type,
          status: this.item.status,
          phone: this.item.phone,
          name: this.item.name,
          region: this.item.region,
          note: this.item.note,
          area_meters: this.item.area_meters,
          general_status: this.item.general_status,
          comment: this.item.comment,
        })
        .then((response) => {
          this.item = Object.assign({}, this.defaultItem);
          this.$emit('saved');
        })
        .catch((response) => {
          this.errors = prepareValidationMessages(response.data.data);
        })
        .finally(() => {
          this.isSaveRequest = false;
        });
    },
  },
};
</script>

<style scoped>

</style>
